<template>
  <div class="mb-5">
    <div>
      <campaign-stat-section-heading
        title="Interest & Engagement"
        description="Total number of interactions with your ad"
        :loading="loading"
      ></campaign-stat-section-heading>
    </div>
    <div class="stat-items-container" v-if="hasData">
      <stat-item-card
        v-if="adClicks"
        :value="adClicks"
        label="Ad Clicks"
        tooltip="Total number of times your ads have been clicked across all media channels"
      ></stat-item-card>
      <stat-item-card
        v-if="ctr"
        :value="ctr"
        label="CTR"
        tooltip="Percentage of people who were served the ad on social media channels and clicked on it"
      ></stat-item-card>
      <stat-item-card
        v-if="socialAdEngagement"
        :value="socialAdEngagement"
        label="Social Ad Engagement"
        tooltip="Total number of interactions with your ads"
      ></stat-item-card>
    </div>
    <no-stat-data-available
      v-if="!loading && !hasData"
      sectionTitle="interest & engagement"
    ></no-stat-data-available>
  </div>
</template>
<script>
import StatItemCard from './StatItemCard.vue';
import CampaignStatSectionHeading from './CampaignStatSectionHeading.vue';
import NoStatDataAvailable from './NoStatDataAvailable.vue';
export default {
  props: ['adClicks', 'ctr', 'socialAdEngagement', 'loading'],
  components: {
    StatItemCard,
    CampaignStatSectionHeading,
    NoStatDataAvailable,
  },
  computed: {
    hasData() {
      if (this.loading) return false;

      return this.adClicks || this.ctr || this.socialAdEngagement;
    },
  },
};
</script>

<style>
.stat-items-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
}
</style>
